import React, { useState } from "react";
import { Modal, Button } from "react-bootstrap";
import { PulseLoader } from "react-spinners";
import { saveAs } from 'file-saver';
import { DownloadPPTVersionDocument } from '../../services/api/ppt-new-api';
import { connect } from 'react-redux';
import { createStructuredSelector } from 'reselect';
import { selectPPTDocumentDetails, selectIsLoadingDocument } from "../../redux/tasks/task-selector";
import { selectUser } from "../../redux/user/user-selector";
import './documentViewerPowerpoint.styles.scss';

const DocumentViewerPowerpoint = ({
    assignmentId,
    showDocumentViewer,
    setShowDocumentViewer,
    setUserActionType,
    isLoadingDocument,
    actionType,
    pptDocument,
    statusAndButtons
}) => {
    //backline controls
    const [toggleBlackline, setToggleBlackline] = useState(false);
    const handleBlackline = () => setToggleBlackline(!toggleBlackline);

    //modal controls
    const handleClose = () => {
        setShowDocumentViewer(false);
        setToggleBlackline(false);
        if (!showAudit){
            setUserActionType('');
        }
    }

    const [showChanged] = useState(actionType.includes("Changed"));
    const [showDownload] = useState(actionType.includes("Download"));
    const [showUpdated] = useState(actionType.includes("Updated"));
    const [showAudit] = useState(actionType.includes("Audit"));

    const downloadVersionFile = async(docType) => {
        const fd = new FormData();
        fd.append("docType", docType);

        await DownloadPPTVersionDocument(assignmentId, fd).then(
            async(result) => {
                return result.blob().then(
                    (blob) => {
                        saveAs(blob, pptDocument.fileName);
                    }
                )
            },
            (error) => {
                console.log(error);
                this.displayAlert("danger", "The file could not be downloaded", "");
            }
        );
    }

    const getSlidePreviews = (slideList, isUpdated) => {
        const getAssignedSlides = (index) => {
            if (statusAndButtons?.Status=="Completed") {
                return (pptDocument.changedSlides.find((slide) => (slide === pptDocument.updatedSlides[index])));
            } else {
                return isUpdated && pptDocument.lockedSlides.includes(index + 1)
            }
        }
        return (
            slideList.map((img, idx) => {
                return (
                    <div class="holder">
                        <img src={img} key={img.slice(-10)} alt="pptx-img-1"
                            class={"pptx-table-body-img" +
                            (isUpdated && getAssignedSlides(idx) ?
                                ' pptx-table-body-img-highlight'
                            :
                                ''
                            )}
                        />
                        <div class="tip"><img src={img} class="large-image" alt="pptx-img-2" /></div>
                    </div>
                )
            })
        );
    }

    return (
        <div className='document-viewer-container'>
            <Modal show={showDocumentViewer} onHide={() => handleClose()} dialogClassName={showUpdated ? "pptx-modal-small" : "pptx-modal"}>
                <Modal.Header closeButton className='pptx-close-btn'>
                {/* Determine title based on action type sent in */}
                <Modal.Title className="pptx-modal-title text-font-styling">
                    { showUpdated ?
                        "Updated Document"
                    : showAudit ?
                        "Document Viewer"
                    : showDownload && showChanged ?
                        "Download Changed Content"
                    : showDownload && !showChanged ?
                        "Download Assigned Content"
                    : !showDownload && showChanged ?
                        "View Changed Content"
                    : !showDownload && !showChanged ?
                        "View Assigned Content"
                    : "" }
                </Modal.Title>

                {   //toggle blackline button
                    showUpdated && !isLoadingDocument && pptDocument.updatedSlides.length > 0 &&
                        <div style={{marginRight:'60px', marginTop: '6px'}}>
                            <Button className='pptx-modal-button-sz text-font-styling' variant='primary' onClick={() => handleBlackline()}>See Blackline</Button>
                        </div>
                }

                </Modal.Header>

                <div className="select-member-divider-line"></div>

                {showUpdated ?
                    //Segment used to display updated content
                    <Modal.Body class="pptx-modal-body">
                        { isLoadingDocument ?
                            <div style = {{'padding' : '30px 100px', 'textAlign' : 'center'}} > <PulseLoader /> </div>
                        :
                            <>
                                <hr />
                                {getSlidePreviews(pptDocument.updatedSlides, false)}
                                <hr />
                                {toggleBlackline &&
                                    <div style={{display: "inline-block", width: "100%"}}>
                                        <hr />
                                        {getSlidePreviews(pptDocument.originalSlides, true)}
                                        <hr />
                                    </div>
                                }
                            </>
                        }
                    </Modal.Body>
                :
                    //Segment used to display assigned/changed content
                    <Modal.Body class="pptx-modal-body">
                        {/*if document still LOADING, show pulseloader o/w show document or document and blackline together*/}
                        { isLoadingDocument ?
                                <div style = {{'padding' : '50px 100px', 'textAlign' : 'center'}} > <PulseLoader /> </div>
                            :
                                <>
                                    { //showAudit &&
                                        //<button className="btn-dark pptx-modal-button-sz" style={{"marginBottom": "30px"}} onClick={() => downloadAllAudit(documentList, auditAction)}>{docPath.length > 1 ? "Download All" : "Download"}</button>
                                    }
                                    <table class="pptx-table">
                                        <tr class="pptx-table-header-row">
                                            <th class="pptx-table-header-cell">ASSIGNED CONTENT</th>
                                            { showChanged &&
                                                <th class="pptx-table-header-cell">CHANGED CONTENT</th>
                                            }
                                            { (showDownload || showAudit) &&
                                                <th class="pptx-table-header-cell" width="15%">ACTION</th>
                                            }
                                        </tr>
                                        <tr>
                                            <th class="pptx-table-body-cell">{getSlidePreviews(pptDocument.assignedSlides, false)}</th>
                                            {   showChanged &&
                                                <th class="pptx-table-body-cell">
                                                    {
                                                        pptDocument.changedSlides.length > 0 ?
                                                            getSlidePreviews(pptDocument.changedSlides, false)
                                                        :
                                                            <div class="no-changed-content">&lt;No Changed Content&gt;</div>
                                                    }
                                                </th>
                                            }
                                            {(showDownload || showAudit) && (
                                                showChanged ?
                                                    pptDocument.changedSlides.length > 0 ?
                                                        <td><button onClick={() => downloadVersionFile("Changed")} className="pptx-table-body-icon" id="download-assigned-content"></button></td>
                                                        :
                                                        <td><button className="pptx-table-body-icon" id="download-content-disabled" disabled></button></td>
                                                    :
                                                    <td><button onClick={() => downloadVersionFile("Changed")} className="pptx-table-body-icon" id="download-assigned-content"></button></td>
                                            )}
                                        </tr>

                                    </table>
                                </>
                        }

                    </Modal.Body>
                }
                <Modal.Footer style={{position: "absolute", bottom: '0', paddingLeft: '39px'}}>
                    {   !showAudit &&
                        <button className="text-font-styling pptx-modal-button-sz btn-light" onClick={() => handleClose()}>Back</button>
                    }
                    {   showUpdated &&
                        <button className="text-font-styling pptx-modal-button-sz btn-dark" onClick={() => downloadVersionFile("Updated")} disabled={isLoadingDocument}>Download</button>
                    }
                </Modal.Footer>
            </Modal>
        </div>
    );
};

const mapState = createStructuredSelector({
    pptDocument: selectPPTDocumentDetails,
    isLoadingDocument: selectIsLoadingDocument,
    user: selectUser
})

export default connect(mapState, null)(DocumentViewerPowerpoint);
